import api from "./index";

export interface SpecialtyTermListParams {
  title?: string;
  order?: "ASC" | "DESC";
  offset?: number;
  limit?: number;
  options?: any;
}

export default (params: SpecialtyTermListParams, options?: any) => {
  return api.SpecialtyTaxonomyApi.list(
    params.title,
    params.order,
    params.offset,
    params.limit,
    options
  );
};
